import { isPlainObject } from "./type-guards-DHLAzjf2.js";

//#region src/internal/user-formatting.ts
function formatUserGeoSummary(value) {
	if (!isPlainObject(value)) return null;
	const parts = [
		value.country_code,
		value.city,
		value.region,
		value.country_name
	].filter((part) => typeof part === "string" && part.length > 0);
	if (parts.length === 0) return null;
	return Array.from(new Set(parts)).join(", ");
}

//#endregion
export { formatUserGeoSummary };
//# sourceMappingURL=user-formatting-BrX0Xi05.js.map